import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { CheckIndicator } from '@sdir/sds';

export enum Status {
  None = 'none',
  Ok = 'ok',
  Valid = 'valid',
  Warning = 'warning',
  Error = 'error',
}

export interface StatusCardProps {
  status: Status;
  title?: string;
  description?: string;
  actions?: ReactNode;
}

const StatusCard: React.FC<StatusCardProps> = ({
  actions,
  status = Status.None,
  title,
  description,
}) => {
  return (
    <BodyFrame className={`status--${status}`}>
      <QualificationBaseHeader title={title} status={status} description={description} />
      <ActionsDiv>{actions}</ActionsDiv>
    </BodyFrame>
  );
};

export default StatusCard;

export const QualificationBaseHeader = ({ description, title, status }) => {
  return (
    <Header>
      <CheckIndicator status={status} />
      <Content>
        {title ? <strong>{title}: </strong> : <></>}
        <div>{description || ''}</div>
      </Content>
    </Header>
  );
};

export const BodyFrame = styled.article`
  padding: 3rem;
  justify-content: center;
  align-items: center;
  height: auto;
  box-shadow: ${({ theme }) => theme.card.boxShadow};
  border-radius: ${({ theme }) => theme.card.borderRadius};
  background-color: ${({ theme }) => theme.colors.background.secondary};
  transition: 250ms ease;
  position: relative;

  &.status {
    &--error {
      border: 1px solid ${({ theme }) => theme.colors.alert.errorDark};
      background-color: ${({ theme }) => theme.colors.alert.errorLight};
    }
    &--warning {
      border: 1px solid ${({ theme }) => theme.colors.alert.warningDark};
      background-color: ${({ theme }) => theme.colors.alert.warningLight};
    }
    &--valid {
      border: 1px solid ${({ theme }) => theme.colors.alert.successDark};
      background-color: ${({ theme }) => theme.colors.alert.successLight};
    }
  }
`;

const Header = styled.div`
  display: flex;

  & > span:first-child {
    min-width: 4rem;
  }
`;
const Content = styled.div`
  line-height: 1.5;
  margin-left: 15px;

  & > div {
    display: inline;
    margin-left: 5px;
  }
`;
const ActionsDiv = styled.div`
  margin-top: 16px;
  margin-left: 4rem;
`;
